<template>
    <div>
        <div v-if="advancedSearchVisible">
            <div class="row">
                <amf-multiple-select class="col-4" label="Type(s)" caption="Show All" v-model="selectedFilters" :options="allStringFilters" :columns="2" />
                <amf-multiple-select class="col-4" label="Tags" caption="--Select Tags--" v-model="selectedTags" :options="allStringTags" :columns="1" />
            </div>
            <div class="row">
                <amf-date-range class="col-4" label="" :startDate.sync="startDate" :endDate.sync="endDate" />
                <div class="search-buttons">
                    <amf-button :onClick="clear" class="ml-2">Clear</amf-button>
                    <amf-button :onClick="closeAdvancedSearch" class="ml-2">Close</amf-button>
                </div>
            </div>
        </div>
        <template v-else>
            <div class="row mb-3">
                <input type="text" class="form-control col-5 ml-3 mr-3" placeholder="Quick Search" v-model="quickSearchText" @input.prevent="debouncedSearch" />
                <amf-button :onClick="showAdvancedSearch">Advanced Search</amf-button>
            </div>
            <div class="row mb-3">
                <div class="form-check ml-3" v-for="filter in quickFilters" :key="filter.id">
                    <input class="form-check-input" type="radio" name="quickfilter" :id="'qf-' + filter.id" 
                        :value="filter.id" v-model="quickFilter" @change="saveState" />
                    <label class="form-check-label" :for="'qf-' + filter.id">{{ filter.name }}</label>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    function getFilter(id, name) {
        return { id, name: name || id };
    }

    const changeLogTags = {};

    const _filters = {
        All : getFilter('All'),
        ChangeLog: getFilter('ChangeLog', 'Change Logs'),
        Changes: getFilter('Changes'),
        Messages: getFilter('Messages'),
        Workflow: getFilter('Workflow'),
        ActionItem: getFilter('ActionItem', 'Action Items'),
        File: getFilter('File', 'Files'),
        Interaction: getFilter('Interaction', 'Interactions'),
        Email: getFilter('Email'),
        SMS: getFilter('SMS', 'Text Messages'),
        Login: getFilter('Login', 'Logins')
    }

    export default {
        props: { entityType: { type: String, required: true } },
        routeQuery: ['quickSearchText:ignoreUpdates', 'startDate', 'endDate', 'selectedFilters', 'selectedTags'],
        localStorage: { key: 'entityType', props: ['quickFilter'] },
        data() {
            return {
                advancedSearchVisible: false,
                quickSearchText: null,
                startDate: null,
                endDate: null,
                selectedTags: null,
                selectedFilters: null,
                quickFilter: 'Changes',
                tags: [],
                allStringTags: [],
                allStringFilters: [],
                debouncedSearch: _.debounce(this.search, 500)
            }
        },
        computed: {
            quickFilters() {
                var arr = [
                    _filters.All,
                    _filters.Changes,
                    _filters.File,
                    _filters.ActionItem,
                    _filters.Interaction,
                ];

                if(this.entityType == 'Participant') {
                    arr.push(_filters.Login);
                    arr.push(_filters.Messages);
                }

                if(this.entityType == 'Employer') {
                    arr.push(_filters.Workflow);
                    arr.push(_filters.Messages);
                }
                
                return arr;
            },
            filters() {
                var arr = [
                    _filters.ActionItem,
                    _filters.ChangeLog,
                    _filters.File,
                    _filters.Interaction
                ]

                if(this.entityType == 'Participant') {
                    arr.push(_filters.Email);
                    arr.push(_filters.SMS);
                    arr.push(_filters.Login);
                }

                return arr;
            }
        },
        async created() {
            if(!changeLogTags[this.entityType])
                changeLogTags[this.entityType] = await romeApi.get(`/config/changelogtags?entityType=${this.entityType}`)

            this.tags = changeLogTags[this.entityType];

            this.allStringTags = this.tags.map(tag => tag.name);
            this.allStringFilters = this.filters.map(f => f.name);
            
            if((!this.quickSearchText && (this.startDate || this.endDate || this.selectedTags || this.selectedFilters)) && !this.advancedSearchVisible)
                this.advancedSearchVisible = true;
            
            this.search({ firstLoad: true });
        },
        methods: {
            onRouteQueryUpdate() {
                this.debouncedSearch();
            },
            clear() {
                this.updateRouteQuery({ startDate: null, endDate: null, selectedTags: null, selectedFilters: null });
            },
            showAdvancedSearch() {
                this.quickSearchText = null;
                this.advancedSearchVisible = true;
            },
            closeAdvancedSearch() {
                this.advancedSearchVisible = false;
                this.clear();
            },
            saveState() {
                this.$saveStateToLocalStorage();
                this.search();
            },
            search(options = {}) {
              
                var searchData = {
                    ...options,
                    quickSearchText: this.quickSearchText,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    tags: this.selectedTags ? this.tags.filter(x => this.selectedTags.includes(x.name)).map(tag => tag.id) : null,
                    filters: ''
                };

                var selectedFilters = this.selectedFilters ? this.filters.filter(x => this.selectedFilters.includes(x.name)) : [];
                var quickFilter = this.quickFilter ? this.quickFilters.find(q => q.id == this.quickFilter) : null;

                if(quickFilter && !this.advancedSearchVisible) {
                    searchData.filters = filterName(quickFilter, this.entityType);
                }
                else {
                    searchData.filters = selectedFilters.map(x => filterName(x, this.entityType)).join(',');
                }
               
                this.$emit('search', searchData);

                function filterName(filter, entityType) {
                    return `${entityType}${filter.id}`;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/history/HistoryFilters.vue